import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <h2 className="font-display font-black uppercase leading-[0.85] tracking-tighter text-5xl sm:text-6xl md:text-7xl">
              Prêt à<br />
              habiller<br />
              <span className="text-[#0044ff]">votre marque.</span>
            </h2>
            <Link
              to="/devis"
              data-testid="footer-cta"
              className="inline-flex items-center gap-3 mt-10 bg-white text-black px-8 py-4 font-bold uppercase tracking-widest text-sm hover:bg-[#0044ff] hover:text-white transition-colors"
            >
              Demander un devis →
            </Link>
          </div>
          <div className="md:col-span-5 grid grid-cols-2 gap-8 self-end text-sm">
            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-4">Studio</p>
              <ul className="space-y-2 text-white/80">
                <li>Personnalisation B2B</li>
                <li>Sérigraphie · Broderie</li>
                <li>Flocage · Sublimation</li>
                <li>Devis en 24h</li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-4">Contact</p>
              <ul className="space-y-2 text-white/80">
                <li>Mirabel.kevin@gmail.com</li>
                <li>Sans engagement</li>
                <li>Livraison France & UE</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs font-mono uppercase tracking-widest text-white/40">
          <span>© {new Date().getFullYear()} MerchStudio</span>
          <span>Fabriqué avec soin.</span>
        </div>
      </div>
    </footer>
  );
}
